// Edit this file to add, remove, reorder, or update faculty members for this department.
const facultyData = {
  "hod": {
    "id": "f-rajeshwari-nanannavar",
    "name": "Mrs. Rajeshwari Nanannavar",
    "designation": "Assistant Professor & Head",
    "role": "Assistant Professor & Head",
    "qualification": "M.Tech.",
    "qualifications": "M.Tech.",
    "image": "/FacultyCImages/rajeshwari_nannavar_EEE.jpeg",
    "email": "rbn@klsvdit.edu.in",
    "phone": "+91 63632 76278",
    "showPhone": true,
    "experience": "14 years",
    "description": "Mrs. Rajeshwari Nanannavar is the Head of the Department of Electrical & Electronics Engineering at KLS VDIT, Haliyal. Her research interests encompass Power Systems and Energy Systems. She is also an active member of the Institution of Engineers(India) - IEI.",
    "bio": "Mrs. Rajeshwari Nanannavar is the Head of the Department of Electrical & Electronics Engineering at KLS VDIT, Haliyal. Her research interests encompass Power Systems and Energy Systems. She is also an active member of the Institution of Engineers(India) - IEI.",
    "specializations": [
      "Power Systems",
      "Energy Systems"
    ],
    "areas": [
      "Power Systems",
      "Energy Systems"
    ],
    "courses": [
      "Power System Operation & Control",
      "Power System Protection",
      "Control Systems",
      "Operational Amplifiers & Linear ICs (Integrated Circuits)"
    ],
    "publications": 3,
    "projects": 2,
    "linkedin": "https://www.linkedin.com/in/rajeshwari-nanannavar-200583413?trk=contact-info",
    "irins": "https://klsvdit.irins.org/profile/248937",
    "recognition": [
      "Member-Institution of Engineers India (IEI)"
    ]
  },
  "members": [
    {
      "id": "f-v-a-kulkarni",
      "name": "Dr. V. A. Kulkarni",
      "designation": "Professor & Principal",
      "role": "Professor & Principal",
      "qualification": "Ph.D.",
      "qualifications": "Ph.D.",
      "image": "/hero_images/VAKulkarni.jpg",
      "email": "principal@klsvdit.edu.in",
      "phone": "+91 94494 54542",
      "showPhone": true,
      "experience": "30 years",
      "description": "Dr. V. A. Kulkarni brings over three decades of teaching experience. He is an approved Ph.D. supervisor at Visvesvaraya Technological University and currently mentors two research scholars. He serves as an Executive Committee Member of VTU NASD, Dandeli.",
      "bio": "Dr. V. A. Kulkarni brings over three decades of teaching experience. He is an approved Ph.D. supervisor at Visvesvaraya Technological University and currently mentors two research scholars. He serves as an Executive Committee Member of VTU NASD, Dandeli. His contributions to technical education have earned him the Best Principal Award from EDUSKILL and AICTE. He is widely recognized for academic leadership and institutional development initiatives.",
      "specializations": [
        "Embedded System",
        "Power Management"
      ],
      "areas": [
        "Embedded System",
        "Power Management"
      ],
      "courses": [
        "Microprocessor",
        "Electrical Power System",
        "Analog & Digital Electronics"
      ],
      "publications": 15,
      "projects": 4,
      "linkedin": "https://www.linkedin.com/in/dr-v-a-kulkarni-288279a?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "irins": "https://klsvdit.irins.org/profile/248910",
      "recognition": [
        "Best Principal Award by EDUSKILL & AICTE",
        "Executive Council member, SGBI Miraj"
      ]
    },
    {
      "id": "f-ravindra-motekar",
      "name": "Mr. Ravindra Motekar",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/ravindra_motekar_EEE.jpeg",
      "email": "rsm@klsvdit.edu.in",
      "phone": "+91 97384 72638",
      "showPhone": false,
      "experience": "13 years",
      "description": "Prof. Ravindra Motekar is serving as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT, Haliyal, with over 11 years of teaching experience. He holds an M.Tech in Industrial Electronics and is currently pursuing a Ph.D. at R.V. College of Engineering, Bangalore. His areas of interest include Industrial Electronics, Smart Grid, Renewable Energy Systems and Power Quality. He is actively involved in academic mentoring, departmental activities, and fostering industry-oriented learning among students.",
      "bio": "Prof. Ravindra Motekar is serving as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT, Haliyal, with over 11 years of teaching experience. He holds an M.Tech in Industrial Electronics and is currently pursuing a Ph.D. at R.V. College of Engineering, Bangalore. His areas of interest include Industrial Electronics, Smart Grid, Renewable Energy Systems and Power Quality. He is actively involved in academic mentoring, departmental activities, and fostering industry-oriented learning among students.",
      "specializations": [
        "Industrial Electronics",
        "Smart Grid",
        "Integration of Renewable Energy",
        "Power Quality"
      ],
      "areas": [
        "Industrial Electronics",
        "Smart Grid",
        "Integration of Renewable Energy",
        "Power Quality"
      ],
      "courses": [
        "Analog Electronic Circuits",
        "Microcontroller",
        "Introduction to Electrical Engineering",
        "Energy Audit and Demand Side Management (DSM)"
      ],
      "publications": 5,
      "projects": 1,
      "linkedin": "https://www.linkedin.com/in/ravi-motekar-3a472072",
      "irins": "https://klsvdit.irins.org/profile/248939",
      "recognition": [
        "Member of professional bodies including Institution of Engineers India (IEI)",
        "Received Karnataka State Council for Science and Technology (KSCST) funding worth Rs 6000/- for Undergraduate (UG) project in year 2021-22",
        "Industrial Experience of 2 years at Wipro Technologies Pune",
        "Institute Level Massive Open Online Course (MOOC) Coordinator",
        "Institute Level Newsletter Coordinator",
        "Department Training & Placement Coordinator",
        "Department Alumni Coordinator",
        "Cultural Coordinator",
      ]
    },
    {
      "id": "f-arun-l-kakhandki",
      "name": "Dr. Arun L. Kakhandki",
      "designation": "Professor",
      "role": "Professor",
      "qualification": "M.Tech., Ph.D.",
      "qualifications": "M.Tech., Ph.D.",
      "image": "/FacultyCImages/DR_arun_kakhandki_EEE.jpeg",
      "email": "alk@klsvdit.edu.in",
      "phone": "+91 98808 41628",
      "showPhone": false,
      "experience": "30 years",
      "description": "Dr. Arun L. Kakhandki has over 26 years of teaching experience in E&C and E&E engineering. His research focuses on WSN, Signal Processing, VLSI & Embedded Systems. Two scholars were awarded Ph.D. under his guidance, and six are pursuing. He has more than thirty publications to his credit. He is a senior member of IEEE and also a member of IETE, IEI & ISTE. He is the IEEE Student Branch Counselor of the institute.",
      "bio": "Dr. Arun L. Kakhandki has over 26 years of teaching experience in E&C and E&E engineering. His research focuses on WSN, Signal Processing, VLSI & Embedded Systems. Two scholars were awarded Ph.D. under his guidance, and six are pursuing. He has more than thirty publications to his credit. He is a senior member of IEEE and also a member of IETE, IEI & ISTE. He is the IEEE Student Branch Counselor of the institute.",
      "specializations": [
        "Wireless Sensor Networks (WSN)",
        "Signal Processing",
        "Very Large Scale Integration (VLSI)",
        "Embedded Systems"
      ],
      "areas": [
        "Wireless Sensor Networks (WSN)",
        "Signal Processing",
        "Very Large Scale Integration (VLSI)",
        "Embedded Systems"
      ],
      "courses": [
        "Computer Communication Networks",
        "Wireless Sensor Networks",
        "Digital System Design",
        "Embedded System Design"
      ],
      "publications": 30,
      "projects": 3,
      "linkedin": "https://www.linkedin.com/in/dr-arun-kakhandki-85a292169",
      "irins": "https://klsvdit.irins.org/profile/249322",
      "recognition": [
        "Research grants worth nearly Rs. 4L in the last 5 years",
        "Reviewer for peer-reviewed journals",
        "Member of professional bodies including Institute of Electrical and Electronics Engineers (IEEE)",
        "Institution of Electronics and Telecommunication Engineers (IETE)",
        "Institution of Engineers India (IEI)",
        "A member of Indian Society for Technical Education (ISTE)",
        "Fellow, Institution of Electronics and Telecommunication Engineers (Institution of Electronics and Telecommunication Engineers (IETE)) (F-503222)",
        "Senior Member, Institute of Electrical and Electronics Engineers (IEEE)",
        "Life Member, A member of Indian Society for Technical Education (ISTE) (LM35179)",
        "Member, Institution of Engineers (IE) (AM094148-7)",
        "Institute of Electrical and Electronics Engineers (IEEE) Student Branch Counselor for the year 2023, 2024, 2025 &",
        "Member, Local Inquiry  Committee (LIC), Visvesvaraya Technological University (VTU), for the year",
        "Member, Local Inquiry  Committee (LIC), Visvesvaraya Technological University (VTU), for the year",
        "Member, BoE, Electronics and Communication (EC) Board, Visvesvaraya Technological University (VTU), for the Academic Year (AY) 2020-21",
        "Funded project from New Age Innovation Network (NAIN), Karnataka Technology (K-Tech), Government of Karnataka (GoK)"
      ]
    },
    {
      "id": "f-varaprasad-gaonkar",
      "name": "Mr. Varaprasad Gaonkar",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.E.",
      "qualifications": "M.E.",
      "image": "/FacultyCImages/varaprasad_gaonkar_EEE.jpeg",
      "email": "vgg@klsvdit.edu.in",
      "phone": "+91 89711 46518",
      "showPhone": false,
      "experience": "14 years",
      "description": "Mr.Varaprasad Gaonkar is an Assistant Professor in the Department of Electrical and Electronics Engineering, currently pursuing a Ph.D. in Power System Congestion Management from VTU.",
      "bio": "Mr.Varaprasad Gaonkar is an Assistant Professor in the Department of Electrical and Electronics Engineering, currently pursuing a Ph.D. in Power System Congestion Management from VTU.",
      "specializations": [
        "Power System Congestion Management",
        "Flexible AC Transmission Systems (FACTS)",
        "Power System Stability Improvement using Flexible AC Transmission Systems (FACTS)"
      ],
      "areas": [
        "Power System Congestion Management",
        "Flexible AC Transmission Systems (FACTS)",
        "Power System Stability Improvement using Flexible AC Transmission Systems (FACTS)"
      ],
      "courses": [
        "Power System Analysis,",
        "Control Systems,",
        "Electric Circuit Analysis,",
        "Electric Motors"
      ],
      "publications": 3,
      "projects": 4,
      "linkedin": "https://www.linkedin.com/in/varaprasad-gaonkar-55300557?trk=contact-info",
      "irins": "https://klsvdit.irins.org/profile/248936",
      "recognition": [
        "Received sponsership of 25k from New Age Innovation Network (NAIN) for innovative project",
        "Member of Institution of Engineers India (IEI)"
      ]
    },
    {
      "id": "f-manjunatha",
      "name": "Mr. Manjunatha",
      "designation": "Assistant Professor & Dean (Admin)",
      "role": "Assistant Professor & Dean (Admin)",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/manjunatha_d_EEE.jpeg",
      "email": "mpd@klsvdit.edu.in",
      "phone": "+91 98801 38746",
      "showPhone": false,
      "experience": "28 years",
      "description": "Mr. Manjunatha is a senior academician with extensive teaching, industry, and administrative experience. Since joining KLS VDIT in 2005, he has played a pivotal role in strengthening academic infrastructure and departmental growth. He served as Head of the Department for 16 years and currently holds the position of Dean (Administration).",
      "bio": "Mr. Manjunatha is a senior academician with extensive teaching, industry, and administrative experience. Since joining KLS VDIT in 2005, he has played a pivotal role in strengthening academic infrastructure and departmental growth. He served as Head of the Department for 16 years and currently holds the position of Dean (Administration).",
      "specializations": [
        "Energy Management",
        "Energy Conservation",
        "Electrical Machines and",
        "Electrical Measurements"
      ],
      "areas": [
        "Energy Management",
        "Energy Conservation",
        "Electrical Machines and",
        "Electrical Measurements"
      ],
      "courses": [
        "Electrical Machines",
        "Electrical and Electronics Measurements",
        "Testing and Commissioning of Power System Equipment"
      ],
      "publications": 1,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/manjunatha-dollin-358177202",
      "irins": "https://klsvdit.irins.org/profile/248912?utm",
      "recognition": [
        "Life Member of A member of Indian Society for Technical Education (ISTE)",
        "Fellow of the Institution of Engineers (FIE) of Institute of Engineers",
        "International Association of Engineers",
        "Teaching Faculty , Dean admin"
      ]
    },
    {
      "id": "f-prakash-laxman-chavan",
      "name": "Mr. Prakash Laxman Chavan",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/prakash_chavan_EEE.jpeg",
      "email": "plc@klsvdit.edu.in",
      "phone": "+91 73874 73539",
      "showPhone": false,
      "experience": "15 years",
      "description": "Prof. Prakash Chavan is an academician and researcher in Electrical Engineering, currently associated with Karnatak Law Society's Vishwanathrao Deshpande Institute of Technology. His areas of interest include power systems, renewable energy, power quality, and engineering education. He actively contributes to research, professional societies, student development, and technical innovation through teaching, publications, and IEEE-related activities.",
      "bio": "Prof. Prakash Chavan is an academician and researcher in Electrical Engineering, currently associated with Karnatak Law Society's Vishwanathrao Deshpande Institute of Technology. His areas of interest include power systems, renewable energy, power quality, and engineering education. He actively contributes to research, professional societies, student development, and technical innovation through teaching, publications, and IEEE-related activities.",
      "specializations": [
        "Power and Energy Systems",
        "Renewable Energy Sources",
        "Power Electronics and Electric Drives"
      ],
      "areas": [
        "Power and Energy Systems",
        "Renewable Energy Sources",
        "Power Electronics and Electric Drives"
      ],
      "courses": [
        "Power Electronics",
        "Industrial Drives and Control",
        "Electric Machines"
      ],
      "publications": 20,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/prakash-chavan-89146457/",
      "irins": "https://klsvdit.irins.org/profile/304300",
      "recognition": [
        "Institute of Electrical and Electronics Engineers (IEEE) Professional Member, Professional Learning and Employment Skills (PLES) Faculty Advisor"
      ]
    },
    {
      "id": "f-vijay-bagewadi",
      "name": "Mr. Vijay Bagewadi",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "",
      "qualifications": "",
      // "image": "/dummy_image.jpeg",
      "email": "",
      "phone": "",
      "showPhone": false,
      "experience": "",
      "description": "Mr. Vijay Bagewadi is an Assistant Professor in the Department of Electrical and Electronics Engineering.",
      "bio": "Mr. Vijay Bagewadi is an Assistant Professor in the Department of Electrical and Electronics Engineering.",
      "specializations": [],
      "areas": [],
      "courses": [],
      "publications": 0,
      "projects": 0,
      "linkedin": "",
      "irins": "",
      "recognition": []
    },
    {
      "id": "f-sheetal-n-mindolkar",
      "name": "Ms. Sheetal N. Mindolkar",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/sheetal_mindolkar_EEE.jpeg",
      "email": "snm@klsvdit.edu.in",
      "phone": "+91 95359 98588",
      "showPhone": false,
      "experience": "3 years",
      "description": "Ms.Sheetal N. Mindolkar is serving as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT, Haliyal, with over 2.8 years of teaching experience. She holds an M. Tech in Industrial Electronics and is passionate about teaching, mentoring, and continuous learning. Her areas of interest include power systems, signal processing, and control systems. She is committed to imparting both theoretical and practical knowledge while fostering innovation, critical thinking, and problem-solving skills among students.",
      "bio": "Ms.Sheetal N. Mindolkar is serving as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT, Haliyal, with over 2.8 years of teaching experience. She holds an M. Tech in Industrial Electronics and is passionate about teaching, mentoring, and continuous learning. Her areas of interest include power systems, signal processing, and control systems. She is committed to imparting both theoretical and practical knowledge while fostering innovation, critical thinking, and problem-solving skills among students.",
      "specializations": [
        "Industrial Electronics",
        "Smart Grid"
      ],
      "areas": [
        "Industrial Electronics",
        "Smart Grid"
      ],
      "courses": [
        "Signals and Digital Signal Processing (DSP)",
        "High Voltage (HV) and Power System Protection",
        "Switchgear and Protection",
        "Basic Electrical Engineering"
      ],
      "publications": 1,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/sheetal-mindolkar-133sh6226",
      "irins": "https://klsvdit.irins.org/profile/441261",
      "recognition": [
        "Active participant in academic and departmental responsibilities.",
        "Dedicated mentor guiding students in projects and technical activities and continuously strives to promote innovation and outcome based learning in Electrical and Electronics Engineering",
        "Department Level Project Coordinator",
        "Department Level Enterprise Resource Planning (ERP) Coordinator",
        "Department Level Newsletter Coordinator",
        "Antiragging Squad"
      ]
    },
    {
      "id": "f-kirankumar-hittanagi",
      "name": "Mr. Kirankumar Hittanagi",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/kiran_hittanagi_EEE.jpeg",
      "email": "knh@klsvdit.edu.in",
      "phone": "+91 95917 03781",
      "showPhone": false,
      "experience": "11 years",
      "description": "Mr. Kirankumar Hittanagi serves as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT. His areas of interest and research include Integrated Renewable Energy Sources, Power Electronics, and Electric Motor Drives. He is currently pursuing Ph.D. in the field of Electrical Engineering with a focus on advancing sustainable and efficient energy systems.",
      "bio": "Mr. Kirankumar Hittanagi serves as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT. His areas of interest and research include Integrated Renewable Energy Sources, Power Electronics, and Electric Motor Drives. He is currently pursuing Ph.D. in the field of Electrical Engineering with a focus on advancing sustainable and efficient energy systems.",
      "specializations": [
        "Integrated Renewable Energy Sources",
        "Power Electronics and Electric Motor Drives"
      ],
      "areas": [
        "Integrated Renewable Energy Sources",
        "Power Electronics and Electric Motor Drives"
      ],
      "courses": [
        "Power Electronics",
        "Industrial Drives and Applications",
        "Introduction to Electrical Engineering",
        "Sensors and Transducers"
      ],
      "publications": 4,
      "projects": 1,
      "linkedin": "https://www.linkedin.com/in/prof-kirankumar-hittanagi-27101990",
      "irins": "https://klsvdit.irins.org/profile/248941",
      "recognition": [
        "Awarded Elite + Gold certification in 12-week National Programme on Technology Enhanced Learning (NPTEL) Online Certification on course titled Smart Grid: Basics to Advanced Technologies by National Programme on Technology Enhanced Learning (NPTEL) (2026)",
        "Received the sponsorship of Rs. 50,000/- from Karnataka Renewable Energy Development Limited (KREDL), Bengaluru for organizing activities on Energy Conservation (2024-25)",
        "Received the grant of Rs. 6000/- from Karnataka State Council for Science and Technology (KSCST) for student project titled \"Internet of Things (IoT) Based Efficiency Monitoring System for Domestic Bio-Gas Plant\" (2020-21)",
        "Successfully completed the National Programme on Technology Enhanced Learning (NPTEL) Online Certification on Research Methodology,",
        "Successfully completed the Certificate Programme on Renewable Energy & Net Zero by Confederation of Indian Industry (Confederation of Indian Industry (CII)), Hyderabad during Feb-2025",
        "Energy Cell Incharge"
      ]
    },
        {
      "id": "f-subrahmanya-hegde",
      "name": "Mr. Subrahmanya Hegde",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/Subramanya H_.jpg",
      "email": "smh@klsvdit.edu.in",
      "phone": "+91 7760372312",
      "showPhone": false,
      "experience": "13 years",
      "description": "Mr. Subrahmanya Hegde serves as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT.A strong interest in effective teaching, research, and practical application-oriented projects. I am passionate about creating an engaging learning environment that helps students understand concepts clearly and apply them to real-world problems. My areas of interest include high-voltage engineering, renewable energy systems, and experimental research.",
      "bio": "Mr. Subrahmanya Hegde serves as an Assistant Professor in the Department of Electrical and Electronics Engineering at KLS VDIT. A strong interest in effective teaching, research, and practical application-oriented projects. I am passionate about creating an engaging learning environment that helps students understand concepts clearly and apply them to real-world problems. My areas of interest include high-voltage engineering, renewable energy systems, and experimental research.",
      "specializations": [
        "Renewable Energy Resources",
        "High Voltage Engineering"
      ],
      "areas": [
        "Renewable Energy Resources",
        "High Voltage Engineering"
      ],
      "courses": [
        "Transmission and Distribution",
        "Transformer and Generator",
        "Basic Electrical Engineering",
        "Energy Audit and Demand Side Management"
      ],
      "publications": 2,
      "projects": 1,
      "linkedin": "https://www.linkedin.com/in/subrahmanya-hegde-38843922a/",
      "irins": "https://klsvdit.irins.org/profile/248938",
      // "recognition": [
      //   "Awarded Elite + Gold certification in 12-week National Programme on Technology Enhanced Learning (NPTEL) Online Certification on course titled Smart Grid: Basics to Advanced Technologies by National Programme on Technology Enhanced Learning (NPTEL) (2026)",
      //   "Received the sponsorship of Rs. 50,000/- from Karnataka Renewable Energy Development Limited (KREDL), Bengaluru for organizing activities on Energy Conservation (2024-25)",
      //   "Received the grant of Rs. 6000/- from Karnataka State Council for Science and Technology (KSCST) for student project titled \"Internet of Things (IoT) Based Efficiency Monitoring System for Domestic Bio-Gas Plant\" (2020-21)",
      //   "Successfully completed the National Programme on Technology Enhanced Learning (NPTEL) Online Certification on Research Methodology,",
      //   "Successfully completed the Certificate Programme on Renewable Energy & Net Zero by Confederation of Indian Industry (Confederation of Indian Industry (CII)), Hyderabad during Feb-2025",
      //   "Energy Cell Incharge"
      // ]
    }
  ]
};

export default facultyData;
